import { Button, Row, Space, Tooltip } from 'antd'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import useSetupHook from './hooks'
import styles from './styles.module.scss'
import { QuestionCircleOutlined, CheckOutlined } from '@ant-design/icons'
import Tippy from '@tippyjs/react'
import _ from 'lodash'
import { orderDetailLinkRender } from '../orderassurance/Lander'
// 订单状态字典
export const orderStateDict = {
  待履约: {
    numstr: '1',
    name: '待履约',
  },
  履约中: {
    numstr: '2',
    name: '履约中',
  },
  待验收: {
    numstr: '3',
    name: '待验收',
  },
  已完成: {
    numstr: '4',
    name: '已完成',
  },
  已取消: {
    numstr: '5',
    name: '已取消',
  },
  已退货: {
    numstr: '6',
    name: '已退货',
  },
  已撤回: {
    numstr: '7',
    name: '已撤回',
  },
}
export const orderStateDictInvert = _.mapKeys(orderStateDict, (o) => o.numstr)

const PayableOrders = () => {
  const {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    handleJump,
  } = useSetupHook()
  const { dataSource, isTableLoading, paginationOption } = state
  const columns = [
    {
      key: 'orderNo',
      dataIndex: 'orderNo',
      title: '客户订单号',
      render: orderDetailLinkRender,
    },
    {
      key: 'customer',
      dataIndex: 'customer',
      title: '客户名称',
    },
    {
      key: 'platform',
      dataIndex: 'platform',
      title: '下单平台',
    },
    {
      key: 'titleOfTheContract',
      title: '签约抬头',
      titleRender: () => (
        <>
          签约抬头
          <Tooltip
            title="此订单与咸亨实际的合同签约抬头，发票的购方和最终咸亨打款账户均以此抬头为准"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined style={{ marginLeft: '5px' }} />
          </Tooltip>
        </>
      ),
      render: (text: string) => text || '万聚国际（杭州）供应链有限公司',
    },
    {
      key: 'orderTime',
      dataIndex: 'orderTime',
      title: '下单时间',
    },
    {
      key: 'orderPrice',
      dataIndex: 'orderPrice',
      title: '下单金额',
    },
    {
      key: 'finalPrice',
      dataIndex: 'finalPrice',
      title: '最终结算金额',
    },
    {
      key: 'orderState',
      dataIndex: 'orderState',
      title: '订单状态',
    },
    {
      key: 'returnState',
      dataIndex: 'returnState',
      title: '对账完毕',
    },
    {
      key: 'paymentMethodList',
      dataIndex: 'paymentMethodList',
      title: '回款方式',
      render: (text: any) => {
        return <span>{text?.join(',')}</span>
      },
    },
    {
      key: 'accountOpenInvoiceStatus',
      dataIndex: 'accountOpenInvoiceStatus',
      title: '供应商开票',
    },
    {
      key: 'invoicingState',
      title: '操作',
      render: (text: any, record: any) => {
        return (
          <span
            className="btn-link"
            onClick={() => {
              handleJump(record)
            }}
          >
            申请付款
          </span>
        )
      },
    },
  ]
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={[
          'orderNo',
          'customer',
          'platform',
          'orderTimeStart',
          'orderTimeEnd',
        ]}
        onSearch={handleSearchClick}
        keyName="PAYABLEORDERS"
        ScreenKey="PAYABLEORDERS"
      />
      <Row justify="space-between" className={styles['info-row']}>
        <Space>
          <Tippy
            content={
              <div className={styles['tooltip-card']}>
                <Row className={styles['header']}>满足以下条件可申请付款</Row>
                <Row className={styles['content']}>
                  <Space>
                    <CheckOutlined
                      style={{
                        color: 'green',
                      }}
                    />
                    <span>签收凭证已确认</span>
                  </Space>
                </Row>
                <Row className={styles['content']}>
                  <Space>
                    <CheckOutlined
                      style={{
                        color: 'green',
                      }}
                    />
                    <span>客户已回款</span>
                  </Space>
                </Row>
                <Row className={styles['content']}>
                  <Space>
                    <CheckOutlined
                      style={{
                        color: 'green',
                      }}
                    />
                    <span>供应商已开票</span>
                  </Space>
                </Row>
              </div>
            }
          >
            <QuestionCircleOutlined />
          </Tippy>
          <span>可付款订单条件</span>
        </Space>
        <Button type="primary" size="middle" onClick={handleBatchRecord}>
          批量申请
        </Button>
      </Row>
      <TableAntd
        dataSource={dataSource}
        listColumn={columns}
        loading={isTableLoading}
        Y={340}
        pagination={{
          ...paginationOption,
          onChange: handlePaginationChange,
        }}
        showSize
        onChangeCheck={handleTableChangeCheck}
      ></TableAntd>
    </div>
  )
}
export default PayableOrders
import { Button, Row, Space, Tooltip } from 'antd'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import useSetupHook from './hooks'
import styles from './styles.module.scss'
import { QuestionCircleOutlined, CheckOutlined } from '@ant-design/icons'
import Tippy from '@tippyjs/react'
import _ from 'lodash'
import { orderDetailLinkRender } from '../orderassurance/Lander'
// 订单状态字典
export const orderStateDict = {
  待履约: {
    numstr: '1',
    name: '待履约',
  },
  履约中: {
    numstr: '2',
    name: '履约中',
  },
  待验收: {
    numstr: '3',
    name: '待验收',
  },
  已完成: {
    numstr: '4',
    name: '已完成',
  },
  已取消: {
    numstr: '5',
    name: '已取消',
  },
  已退货: {
    numstr: '6',
    name: '已退货',
  },
  已撤回: {
    numstr: '7',
    name: '已撤回',
  },
}
export const orderStateDictInvert = _.mapKeys(orderStateDict, (o) => o.numstr)

const PayableOrders = () => {
  const {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    handleJump,
  } = useSetupHook()
  const { dataSource, isTableLoading, paginationOption } = state
  const columns = [
    {
      key: 'orderNo',
      dataIndex: 'orderNo',
      title: '客户订单号',
      render: orderDetailLinkRender,
    },
    {
      key: 'customer',
      dataIndex: 'customer',
      title: '客户名称',
    },
    {
      key: 'platform',
      dataIndex: 'platform',
      title: '下单平台',
    },
    {
      key: 'titleOfTheContract',
      title: '签约抬头',
      titleRender: () => (
        <>
          签约抬头
          <Tooltip
            title="此订单与咸亨实际的合同签约抬头，发票的购方和最终咸亨打款账户均以此抬头为准"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined style={{ marginLeft: '5px' }} />
          </Tooltip>
        </>
      ),
      render: (text: string) => text || '万聚国际（杭州）供应链有限公司',
    },
    {
      key: 'orderTime',
      dataIndex: 'orderTime',
      title: '下单时间',
    },
    {
      key: 'orderPrice',
      dataIndex: 'orderPrice',
      title: '下单金额',
    },
    {
      key: 'finalPrice',
      dataIndex: 'finalPrice',
      title: '最终结算金额',
    },
    {
      key: 'orderState',
      dataIndex: 'orderState',
      title: '订单状态',
    },
    {
      key: 'returnState',
      dataIndex: 'returnState',
      title: '对账完毕',
    },
    {
      key: 'paymentMethodList',
      dataIndex: 'paymentMethodList',
      title: '回款方式',
      render: (text: any) => {
        return <span>{text?.join(',')}</span>
      },
    },
    {
      key: 'accountOpenInvoiceStatus',
      dataIndex: 'accountOpenInvoiceStatus',
      title: '供应商开票',
    },
    {
      key: 'invoicingState',
      title: '操作',
      render: (text: any, record: any) => {
        return (
          <span
            className="btn-link"
            onClick={() => {
              handleJump(record)
            }}
          >
            申请付款
          </span>
        )
      },
    },
  ]
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={[
          'orderNo',
          'customer',
          'platform',
          'orderTimeStart',
          'orderTimeEnd',
        ]}
        onSearch={handleSearchClick}
        keyName="PAYABLEORDERS"
        ScreenKey="PAYABLEORDERS"
      />
      <Row justify="space-between" className={styles['info-row']}>
        <Space>
          <Tippy
            content={
              <div className={styles['tooltip-card']}>
                <Row className={styles['header']}>满足以下条件可申请付款</Row>
                <Row className={styles['content']}>
                  <Space>
                    <CheckOutlined
                      style={{
                        color: 'green',
                      }}
                    />
                    <span>签收凭证已确认</span>
                  </Space>
                </Row>
                <Row className={styles['content']}>
                  <Space>
                    <CheckOutlined
                      style={{
                        color: 'green',
                      }}
                    />
                    <span>客户已回款</span>
                  </Space>
                </Row>
                <Row className={styles['content']}>
                  <Space>
                    <CheckOutlined
                      style={{
                        color: 'green',
                      }}
                    />
                    <span>供应商已开票</span>
                  </Space>
                </Row>
              </div>
            }
          >
            <QuestionCircleOutlined />
          </Tippy>
          <span>可付款订单条件</span>
        </Space>
        <Button type="primary" size="middle" onClick={handleBatchRecord}>
          批量申请
        </Button>
      </Row>
      <TableAntd
        dataSource={dataSource}
        listColumn={columns}
        loading={isTableLoading}
        Y={340}
        pagination={{
          ...paginationOption,
          onChange: handlePaginationChange,
        }}
        showSize
        onChangeCheck={handleTableChangeCheck}
      ></TableAntd>
    </div>
  )
}
export default PayableOrders
